import { render, staticRenderFns } from "./MenuItemLink.vue?vue&type=template&id=469fa109&"
import script from "./MenuItemLink.vue?vue&type=script&lang=ts&"
export * from "./MenuItemLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports